import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {IEventBlock, IEventFinder} from "../../../interfaces";
import {Compbaser} from "../../../components/compbaser";
import {TranslocoService} from "@ngneat/transloco";
import {SelectionChange} from "@angular/cdk/collections";
import {Subject} from "rxjs";
import {startWith} from "rxjs/operators";

@Component({
    selector: 'app-dialog-events-explorer',
    templateUrl: './dialog-events-explorer.component.html',
    styleUrls: ['./dialog-events-explorer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogEventsExplorerComponent extends Compbaser implements OnInit {

    m_data: IEventBlock;
    selection: Subject<SelectionChange<string>>;
    event: IEventBlock;

    constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA)
                public data: IEventBlock,
                private translocoService: TranslocoService,
                private cd: ChangeDetectorRef) {
        super();
        this.m_data = data;
    }

    ngOnInit() {
    }

    import(e) {
        this.event.payload = this.m_data;
        this.dialogRef.close(this.event);
    }

    onSelectedMode(i_selectionModel) {
        this.selection = i_selectionModel.pipe(startWith([]));
        this.cod(
            i_selectionModel.pipe(startWith([]))
                .subscribe((v) => {
                    this.event = v.source?.selected?.[0];
                })
        );
        this.cd.detectChanges();
    }

    override destroy() {
        this.selection = null;
        super.destroy();
    }
}
